// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__Wm87P"};